export default "__VITE_ASSET__DrpO0r3$__"